import { configureStore } from "@reduxjs/toolkit";
import PaymentReducer from "./slices/paymentSlice/PaymentSlice";
import ProfileReducer from "./slices/profileSlice/ProfileSlice";
import ExcludeClientReducer from "./slices/excludeClientSlice/ExcludeClientSlice";

const store = configureStore({
  reducer: {
    paymentReducer: PaymentReducer,
    profileReducer: ProfileReducer,
    excludeClientReducer: ExcludeClientReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
